import React from 'react'
import { MdOutlinePushPin } from 'react-icons/md'
import { MdCreate, MdDelete } from 'react-icons/md'
import moment from 'moment';


const NoteCard = ({
    title,
    date,
    content,
    tags,
    isPinned,
    onNoteClick,
    onEdit,
    onDelete,
    onPinNote,
}) => {
    return (
        <div  className="border mt-2  rounded p-4 bg-white hover:shadow-xl transition-all ease-in-out">
            <div className='flex items-center justify-between' >
                <div >
                    <h6 onClick={onNoteClick} className="cursor-pointer text-base font-bold">{title}</h6>
                    <span className="text-xs text-slate-500">{moment(date).format('Do MM YYYY')}</span>
                </div>
                <MdOutlinePushPin className={`icon-btn hover:text-blue-500 ${isPinned ? 'text-blue-500' : 'text-slate-300'}`} onClick={onPinNote} />
            </div>
            <p className="text-md text-slate-600 mt-2">{content?.slice(0, 60)}</p>


            <div className="flex justify-between mt-2 items-center ">
                <div className="text-xs text-slate-500">{tags.map(item => ` #${item}`)}</div>
                <div className='flex gap-1'>

                    <MdCreate
                        className="icon-btn hover:text-green-600"
                        onClick={onEdit}
                    />
                    <MdDelete
                        className="icon-btn hover:text-red-500"
                        onClick={onDelete}
                    />

                </div>
            </div>
        </div>

    )
}

export default NoteCard
